import { useRef, useEffect } from 'react'

import { css } from 'styled-components'

const hotScrollStyles = css`
  ._hot-scroll::-webkit-scrollbar-track {
    background-color: var(--gray-100, #f7f9fa);
  }

  ._hot-scroll::-webkit-scrollbar-thumb {
    background-color: var(--structure-menu-item-bg, #fdece7);
  }
`

export const useMenuRef = () => {
  const menuRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (menuRef?.current) {
      const hotScrollStyle = document.createElement('style')

      hotScrollStyle.innerHTML = hotScrollStyles.toString()

      const shadowRootMenu = menuRef.current.shadowRoot

      const hotAppMenu = shadowRootMenu?.querySelector('.hot-application__menu') as HTMLDivElement

      hotAppMenu.prepend(hotScrollStyle)
    }
  }, [])

  return { menuRef }
}
